import { Button, Stack, Typography, Box } from "@mui/material";
import React, { useState } from "react";
import QrReader from "react-web-qr-reader";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

function ScanQr() {
  const [showScanner, setShowScanner] = useState(false);
  return (
    <Stack
      minHeight="100vh"
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ p: 3, bgcolor: "background.surface", textAlign: "center" }}
    >
      <Box sx={{ color: "primary.main", "& svg": { fontSize: 56 } }}>
        <QrCodeScannerIcon />
      </Box>
      <Typography variant="h4" component="h1">
        Scan QR code
      </Typography>
      <Typography color="text.secondary" sx={{ maxWidth: 360 }}>
        Scan the QR code at your table or venue to start your order.
      </Typography>
      <Button
        size="large"
        sx={{ minHeight: 48, minWidth: 200 }}
        onClick={() => setShowScanner(!showScanner)}
      >
        {showScanner ? "Cancel" : "Click to Scan"}
      </Button>
      {showScanner && (
        <Box sx={{ borderRadius: 3, overflow: "hidden", boxShadow: "0 2px 12px rgba(28, 28, 78, 0.12)" }}>
          <QrReader
            delay={100}
            style={{
              height: 320,
              width: 320,
            }}
            onError={(error) => console.log("error", error)}
            onScan={(res) => {
              if (res && res?.data) {
                setShowScanner(false);
                window.location.href = res?.data;
              }
            }}
          />
        </Box>
      )}
    </Stack>
  );
}

export default ScanQr;
